<!-- Sprite-based display (Azure CDN optimized) -->
@if (spriteData()) {
  <div class="sprite-icon" [ngStyle]="spriteStyles()"></div>
}
